// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class StytchErrorMessage {
    public static readonly errorMessageId = 'stytch-error-message';
}

export default StytchErrorMessage;
